// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
import { AutocompleteInput } from "react-admin";
import DisableHandleKeyDown from "./DisableHandleKeyDown";
const AutocompleteInputStyle = styled(AutocompleteInput)(({ theme }) => ({
  width: "260px",
  "& .MuiAutocomplete-clearIndicator": {
    display: "none",
  },
}));

const CustomAutocompleteInput = ({ ...props }) => {
  return (
    <AutocompleteInputStyle
      {...props}
      variant={
        props?.variant && props.variant.trim() !== ""
          ? props.variant
          : "outlined"
      }
      onKeyDown={(event: any) => {
        DisableHandleKeyDown(event);
      }}
    />
  );
};
export default CustomAutocompleteInput;
